import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
  },
  headerHeading: {
    color: 'white',
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: 'md',
    fontWeight: 'medium',
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'white',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    py: '2',
    px: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    variant: 'filter',
    boxShadow: 'none',
    bg: 'none',
    maxH: '9',
    pos: 'relative',
  },
  toMarketButton: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      color: 'beta.800',
    },
    _hover: {
      color: 'beta.500',
    },
    _after: {
      bgImage: 'none',
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bg: 'alpha.500',
    border: '0',
    borderRadius: 'base',
    overflow: 'hidden',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    boxShadow:
      '0px -1px 0px 0px rgba(255, 255, 255, 0.20) inset, 0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
    _hover: {
      bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    color: 'gamma.900',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'white',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'gamma.900',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    bg: 'none',
    boxShadow: 'none',
    w: '660px',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },

      '&[data-active], :active': {
        color: 'beta.500',
        bg: 'none',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    borderColor: 'gamma.400',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
    sx: {
      svg: {
        color: 'gamma.900',
        fill: 'gamma.900',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'alpha.700',
        fill: 'alpha.700',
        textShadow: '0px 1px 1px rgba(255, 255, 255, 0.50)',
      },

      '&&': {
        border: 'none',
        bg: 'beta.500',
        boxShadow: '0px 3px 0px 0px #BE49BF inset',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
